function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import styled, { createGlobalStyle } from 'styled-components';
const GlobalStyle = createGlobalStyle(["*,*::before,*::after{box-sizing:border-box;-webkit-font-smoothing:antialiased;}*{margin:0;}body{font-size:14px;margin:0;font-family:-apple-system,BlinkMacSystemFont,avenir next,avenir,segoe ui,helvetica neue,helvetica,Ubuntu,roboto,noto,arial,sans-serif;}table{border-collapse:collapse;border-spacing:0;}[role=\"button\"]:focus:not(:focus-visible):not(.focus-visible),[role=\"tabpanel\"][tabindex=\"0\"]:focus:not(:focus-visible):not(.focus-visible),button:focus:not(:focus-visible):not(.focus-visible),summary:focus:not(:focus-visible):not(.focus-visible),a:focus:not(:focus-visible):not(.focus-visible){outline:none;box-shadow:none;}[tabindex=\"0\"]:focus:not(:focus-visible):not(.focus-visible),details-dialog:focus:not(:focus-visible):not(.focus-visible){outline:none;}"]);
const Base = styled.div.withConfig({
  displayName: "BaseStyles__Base",
  componentId: "sc-xh4jdo-0"
})([""]);
function BaseStyles(props) {
  const {
    children,
    ...rest
  } = props;

  // load polyfill for :focus-visible
  require('focus-visible');
  return /*#__PURE__*/React.createElement(Base, _extends({}, rest, {
    "data-portal-root": true
  }), /*#__PURE__*/React.createElement(GlobalStyle, null), children);
}
BaseStyles.displayName = "BaseStyles";
export default BaseStyles;